import { getPathFromState as defaultGetPathFromState, LinkingOptions } from '@react-navigation/native';
import paths from './paths';
import { generateWatchlistItemId } from './utilts';

type Linking = LinkingOptions<ReactNavigation.RootParamList>;

const linking: Linking = {
    prefixes: ['localhost'], // TODO: deep linking
    config: {
        screens: {
            Loading: paths.loading,
            Login: paths.login,
            LoginIB: paths.loginIB,
            LoginAsCustomer: paths.loginAsCustomer,
            AutoLogin: paths.autoLogin,
            LoginSessionId: paths.loginSessionId,
            Registration: paths.registration,
            RegistrationInvesting: paths.registrationInvesting,
            ForgotPassword: paths.forgotPassword,
            ResetPassword: paths.resetPassword,
            Confirmation: paths.confirmation,
            Chart: paths.chartingLibrary,
            Desktop: paths.desktop,
            HomeTabs: {
                screens: {
                    DealsStack: {
                        screens: {
                            EditOpenPosition: paths.editOpenPosition,
                            EditPendingOrder: paths.editPendingOrder,
                            DealsTopTabs: {
                                screens: {
                                    OpenTrades: paths.openTrades,
                                    AllOrders: paths.allOrders,
                                    Result: paths.result,
                                    Cash: paths.cash,
                                    Commissions: paths.commissions,
                                    InterestSwap: paths.interestSwap,
                                },
                            },
                        },
                    },
                    MarketsStack: {
                        screens: {
                            EditFavoritesList: paths.editFavoritesList,
                            BuySellPosition: paths.buySellPosition,
                            MarketOrder: paths.marketOrder,
                            Investments: paths.investments,
                            MarketTopTabs: {
                                screens: {},
                            },
                        },
                    },
                    NewsStack: {
                        screens: {
                            News: paths.news,
                            Notifications: paths.notifications,
                        },
                    },
                    AIStrategyStack: {
                        screens: {
                            AIStrategiesList: paths.aiStrategy,
                            AIStrategyDetails: paths.aiStrategyDetails,
                        },
                    },
                    MoreStack: {
                        screens: {
                            More: paths.more,
                            Settings: paths.settings,
                            Accounts: paths.accounts,
                            ChangePassword: paths.changePassword,
                            NotificationsSettings: paths.notificationsSettings,
                            WithdrawFunds: paths.withdrawFunds,
                            AddFunds: paths.addFunds,
                            AddFundsCategory: paths.addFundsCategory,
                            AddFundsCard: paths.addFundsCard,
                            AddFundsCardPaymentProvider1: paths.addFundsCardPaymentProvider1,
                            AddFundsCardPaymentProvider1Select: paths.addFundsCardPaymentProvider1Select,
                            AddFundsCardPaytiko: paths.addFundsCardPaytiko,
                            AddFundsAlternativePayment: paths.addFundsAlternativePayment,
                            AddFundsAlternative: paths.addFundsAlternative,
                            AddFundsBank: paths.addFundsBank,
                            UploadDocuments: paths.uploadDocuments,
                            VerificationCenter: paths.verificationCenter,
                            ClientReport: paths.clientReport,
                            ResultReport: paths.resultReport,
                            SwapReport: paths.swapReport,
                            LegalDocuments: paths.legalDocuments,
                            TermsOfBusiness: paths.termsOfBusiness,
                            OrderExecutionPolicy: paths.orderExecutionPolicy,
                            RiskDisclosureNotice: paths.riskDisclosureNotice,
                            PrivacyPolicy: paths.privacyPolicy,
                            CopyTradingAgreement: paths.copyTradingAgreement,
                        },
                    },
                },
            },
        },
    },
    // Desktop is a single screen whose panes are internal state, not routes. Some panes still
    // mount navigators of their own (the strategy detail's tab sets), and every navigator inside
    // the container contributes its active route to the path — which produced URLs like
    // /desktop/LivePositions that no config could match, so reloading them fell back to /desktop
    // and the default pane. Collapsing the path keeps it honest about what can be restored.
    getPathFromState: (state, config) => {
        const path = defaultGetPathFromState(state, config);
        return path === paths.desktop || path.startsWith(`${paths.desktop}/`) ? paths.desktop : path;
    },
};

export const updateLinking = (cb: (l: Linking) => void) => cb(linking);

export const setWatchlistLinking = (ids: number[]) => {
    const screens: { [key: string]: string } = (linking as any).config.screens.HomeTabs.screens.MarketsStack.screens
        .MarketTopTabs.screens;
    for (const id of ids) {
        screens[generateWatchlistItemId(id)] = paths.watchlistItem(id);
    }
};

export const isLoginSessionIdUrl = (url: string) => url.includes(paths.loginSessionId);

export const getLinking = () => linking;
